class FetchAiModels {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiModels;
